module.exports = __webpack_public_path__ + "img/按钮关闭蓝色.c3a769fb.png";